jQuery($ => {
    if ($('.o-header')[0]) {
        $(window).on('scroll', function () {
            const scroll    = $(this).scrollTop();
            const $header   = $('.o-header');
            const stickyPos = $('.o-header').height();

            if (scroll > 10) {
                $('.o-header').addClass('o-header--sticky');
            } else {
                $('.o-header').removeClass('o-header--sticky');
            }
        });
    }
});